import templateUrl from './display-rounded-cover-pic.html';

export const displayRoundedCoverPicComponent = {
    bindings: {
        coverPicUrl: '@',
        status: '@',
        isBasicDetailsCoverPhoto: '@'
    },

    templateUrl,

    controller: class DisplayRoundedCoverPicComponent {
        constructor($parse) {
            'ngInject';

            this.$parse = $parse;
        }

        $onInit() {
            this._isBasicDetailsCoverPhoto = this.$parse(this.isBasicDetailsCoverPhoto || 'false')(false);
        }

        $onChanges(changes) {
            if (changes.coverPicUrl && !changes.coverPicUrl.isFirstChange()) {
                this.coverPicUrl = changes.coverPicUrl.currentValue;
            }
        }

        setCssClassNameForStatusObject(status) {
            let statusObject = {
                status: status
            };
            switch (status) {
                case 'rejected':
                    statusObject.iconClass = 'icon-status_reject';
                    break;

                case 'blocked':
                    statusObject.iconClass = 'icon-status_block';
                    break;

            }
            return statusObject;
        }


    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/display-rounded-cover-pic/display-rounded-cover-pic.component.js